import { createSlice } from "@reduxjs/toolkit";
import { Clinics, Role, User } from "generated/graphql";

interface userState {
  data: User | null;
  role: Role | null;
  clinic: Clinics | null;
}

const initialState: userState = {
  data: null,
  role: null,
  clinic: null,
};

export const usersSlice = createSlice({
  name: "loggedInUser",
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.data = action.payload.data;
      state.role = action.payload.role;
      state.clinic = action.payload.clinic;
    },
    logoutUser: (state) => {
      state.data = null;
      state.role = null;
      state.clinic = null;
    },
    setUserData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { loginUser, logoutUser, setUserData } = usersSlice.actions;

export default usersSlice.reducer;
